<template>
  <div>

    <h2>{{ $t('title.' + action + '.user-level') }}</h2>

    <el-row>

      <el-col :span="24">

        <data-form
          model="user-levels"
          :entity="userLevel"
          :fields="fields"
          :before-submit="beforeSubmit"
          :after-submit="afterSubmit">

          <label>{{ $t('related-app-functions') }}</label>

          <div style="margin-bottom: 50px">

            <data-table
              ref="functionTable"
              model="app-functions"
              :columns="['[T]name']"
              :isSelected="isAppFunctionSelected"
              :size="30"
              @selection-change="appFunctionSelectChanged"/>

          </div>

          </data-form>

      </el-col>

    </el-row>

  </div>
</template>

<script>
export default {
  name: 'user-level-details',
  data () {
    return {
      relatedAppFunctions: [],
      fields: {
        'name': {
          type: 'text',
          rules: [{ required: true }, { max: 80 }]
        }
      }
    }
  },
  computed: {
    userLevel () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true }
      }

      return this.$store.getters['user-levels/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.userLevel.new ? 'create' : 'edit'
    }
  },
  watch: {
    userLevel () {
      // If the related AppFunction list was retrieved first then force the table to rerender
      // It will assure that the related AppFunction checkboxes are checked
      this.$refs.functionTable.tableDataChanged = true
    }
  },
  methods: {
    beforeSubmit (formModel) {
      formModel.relatedAppFunctions = this.relatedAppFunctions.map((i) => i.id)
    },
    afterSubmit (formModel) {
      this.$router.back()
    },
    isAppFunctionSelected (appFunction) {
      if (!this.userLevel.appFunctions) return false
      return (this.userLevel.appFunctions).map(f => f.id).includes(appFunction.id)
    },
    appFunctionSelectChanged (selection) {
      this.relatedAppFunctions = selection
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserLevelDetails.vue?3a546c58